module.exports = "/images/close.png?7d1c2c4a04b27d4bc04e4f5126252de2";